import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-loyers-impayes',
  standalone: true,
  imports: [CommonModule, RouterModule, PageLayoutComponent],
  templateUrl: './assurance-loyers-impayes.component.html',
  styleUrls: ['./assurance-loyers-impayes.component.scss']
})
export class AssuranceLoyersImpayesComponent {
  title = 'Assurance Loyers Impayés';
  subtitle = '';
  phoneNumber = '01 43 27 12 43';
  heroImage = 'assets/static_pages_images/gli.jpg';
  
  breadcrumbs = [
    { label: 'Particuliers', link: undefined },
    { label: 'Assurance Loyers Impayés', link: undefined }
  ];

  prevPage = { 
    title: 'Assurance Immeuble multirisque - MRI - PNO',
    link: '/assurance-multirisque-immeuble-pno'
  };

  nextPage = { 
    title: 'Assurance Protection Juridique',
    link: '/assurance-protection-juridique'
  };

  // Partners logos for carousel
  partners = [
    { name: 'Insured', logo: 'assets/logos/insured.png' },
    { name: 'Netvox', logo: 'assets/logos/netvox.png' },
    { name: 'Solly Azar', logo: 'assets/logos/solly-azar.png' },
  ];

  constructor(private router: Router) {}

  navigateToComparison(): void {
    this.router.navigate(['/cac/comparaison']);
  }
}
